module.exports = __webpack_public_path__ + "static/media/HOX.916d9085.svg";